///////////////////
//
///////////////////
import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    HostListener,
    Injector,
    Injectable,
} from "@angular/core";

import { AuthenticationService } from "../../../core/auth/authentication.service";
import { Router } from "@angular/router";
import { LocalStorageService } from "../../../core/local-storage.service";

@Component({
    selector: "djiv-user-menu",
    templateUrl: "./djiv-user-menu.component.html",
    styleUrls: ["./djiv-user-menu.component.css"],
})
export class DJIVUserMenuComponent implements OnInit {
    @ViewChild("djivUserMenu") userMenu: ElementRef;
    @ViewChild("djivUserDropDown") userDropDown: ElementRef;

    public hasAuthProviders: boolean;
    public showSignOut = false;
    private canShowSignOut = false;
    protected supplierName: string = "";

    private localStorage: LocalStorageService;

    constructor(
        private authenticationService: AuthenticationService,
        private router: Router,
        @Injectable() injector: Injector
    ) {
        this.hasAuthProviders = this.authenticationService.requireSignIn;
        this.showSignOut = false;
        this.supplierName = sessionStorage.getItem("SupplierApp.supplierName");

        this.localStorage = injector.get(LocalStorageService);
    }

    public ngOnInit() {
        this.authenticationService
            .isAuthenticated()
            .subscribe((isAuthenticated) => {
                this.canShowSignOut = isAuthenticated;
            });
    }

    public toggleSignOut() {
        this.userMenu.nativeElement.classList.toggle("showMenu");
    }

    public signOut() {
        sessionStorage.removeItem("SupplierApp.autologin");
        sessionStorage.removeItem("SupplierApp.supplierName");
        this.localStorage.removeItem("bookingFilterField");
        this.localStorage.removeItem("bookingFilterOperator");
        this.localStorage.removeItem("bookingFilterValue");
        this.authenticationService.signOut();
        this.closeUserMenu();
    }

    public goToSettings() {
        this.router.navigate(["general/app-settings"]);
    }

    @HostListener("document:click", ["$event.target"])
    public onClick(targetElement) {
        // Check if click was outside of user dropdown so we can close it
        if (!this.userDropDown.nativeElement.contains(targetElement)) {
            this.closeUserMenu();
        }
    }

    private closeUserMenu() {
        this.userMenu.nativeElement.classList.remove("showMenu");
    }
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/djiv-user-menu/djiv-user-menu.component.ts